import "core-js/full/typed-array/to-base64";

import UArray from "@repo/utils/UArray";
import UHTMLInputElement from "./UHTMLInputElement.mjs";

declare global {
  interface Uint8Array {
    toBase64(): string;
  }
}

namespace UFile {
  export async function load(url: string, name?: string) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], name ?? url.split("/").pop()!, { type: blob.type });
  }

  export const toBase64 = async (file: File) =>
    new Uint8Array(await file.arrayBuffer()).toBase64();

  export async function promptUpload(
    accept: UArray.Maybe<UHTMLInputElement.File.Accept>,
  ) {
    return new Promise<File>((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = UArray.ensure(accept).join(",");
      input.onchange = async () => {
        const file = input.files?.[0];
        if (file) resolve(file);
      };
      input.click();
    });
  }
}

export default UFile;
